/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var lastScrollTop = 0

// document.addEventListener("scroll", function() {
//     let headerEl = document.getElementById('Header') 
//     var st = window.pageYOffset || document.documentElement.scrollTop
//     if (st > lastScrollTop) {
//         headerEl.classList.remove('scroll')
//         headerEl.classList.remove('fixed')
//     } else if (st < lastScrollTop) {
//         headerEl.classList.remove('fixed')
//         headerEl.classList.add('scroll')
//     }
//     let height = getComputedStyle(document.documentElement)
//     .getPropertyValue('--navbar-height')
//     .replace('px', '')
//     if (lastScrollTop <= Number(height) + 5) {
//         headerEl.classList.remove('scroll')
//         headerEl.classList.add('fixed')
//     }
//     lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
//  }, false)

window.addEventListener('scroll', function() {
    // let header = document.querySelector('#Header')
    // var st = window.pageYOffset || document.documentElement.scrollTop
    // header.classList.toggle('sticky',st > lastScrollTop)
    // lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
})